import React, { useEffect } from 'react'

export function HtmlTagSchemaMarkup({ type }) {
    useEffect(() => {
        document.documentElement.setAttribute('itemscope', '');
        document.documentElement.setAttribute('itemtype', `https://schema.org/${type}`);
    }, [type])

    return null
}
